module.exports = __webpack_public_path__ + "static/media/gluten.3ccb5bff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/gluten.svg
// module id = 1123
// module chunks = 0